<template>
<div>
          <div class="company_container" ref="container">
      <div
        class="image-container"
        ref="imageContainer"
        :style="{ transform: `translateX(-${currentPosition}px)` }"
      >
        <img ref="image" src="../assets/img/c2.png" @load="initAnimation" />
      </div>
    </div>
    <div class="company_container" ref="container">
      <div
        class="image-container"
        ref="imageContainer"
        :style="{ transform: `translateX(-${currentPosition}px)` }"
      >
        <img ref="image" src="../assets/img/c1.png" @load="initAnimation" />
      </div>
    </div>
  <div id="footer">
    <div class="footer_mn">
      <div class="footer_top">
        <div class="logo">
          <img src="@/assets/img/ft_logo.png" alt="logo图">
        </div>
        <div class="footer_top_right">
          <div class="footer_top_right_item">
            <div><img src="@/assets/img/ft_dyewm.png" class="ewm"/></div>
            <img src="@/assets/img/ft_hd.png"/>
          </div>
          <div class="footer_top_right_item">
            <div><img src="@/assets/img/ft_bmewm.png" class="ewm"/></div>
            <img src="@/assets/img/ft_dy.png" />
          </div>
        </div>
      </div>
      <div class="footer_center">
        <div class="footer_center_left">
          <ul class="footer_center_list">
            <li>
              <ul>
                <li class="footer_center_list_item">主营业务</li>
                <li class="footer_center_list_item">瓦斯利用解决方案</li>
                <li class="footer_center_list_item">智慧管理平台</li>
                <li class="footer_center_list_item">智慧矿山</li>
              </ul>
            </li>

            <li>
              <ul>
                <li class="footer_center_list_item">客户案例</li>
                <li class="footer_center_list_item">公司案例</li>
              </ul>
            </li>
            <li>
              <ul>
                <li class="footer_center_list_item">新闻动态</li>
                <li class="footer_center_list_item">公司动态</li>
                <li class="footer_center_list_item">行业新闻</li>
              </ul>
            </li>
            <li>
              <ul>
                <li class="footer_center_list_item">关于我们</li>
                <li class="footer_center_list_item">公司简介</li>
                <li class="footer_center_list_item">荣誉资质</li>
                <li class="footer_center_list_item">联系我们</li>
              </ul>
            </li>
          </ul>

        </div>
        <div>
          <div class="footer_center_right_item">
            <div class="footer_center_right_item_img_box"><img src="@/assets/img/ft_tel.png" /></div>
            <span>0356-3800710</span>
          </div>
          <div class="footer_center_right_item">
            <div class="footer_center_right_item_img_box"><img src="@/assets/img/emaill.png" /></div>
            <span>shanxigentory@gentory.cn</span>
          </div>
          <div class="footer_center_right_item">
            <div class="footer_center_right_item_img_box"><img src="@/assets/img/dw.png" /></div>
            <span>山西省晋城市开发区太岳街2168号博洋国际</span>
          </div>
          <div class="footer_center_right_ewm_box">
            <div><img src="@/assets/img/ft_wxerm.png" />
              <p>微信公众号</p>
            </div>
            <div><img src="@/assets/img/ft_bmewm.png" />
              <p>报价咨询</p>
            </div>
          </div>

        </div>
      </div>
      <div class="footer_bootom">
        <div>备案号：晋ICP备20000303号-1</div>
        <div class="footer_bootom_yin"><span>隐私声明</span><span>使用条款</span></div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
            currentPosition: 0,
      direction: 1,
      speed: 100, // 像素/秒
      maxScroll: 0,
      lastTime: null,
      animationFrameId: null,
    };
  },
    methods: {
    initAnimation() {
      this.calculateMaxScroll();
      this.startAnimation();
    },
    calculateMaxScroll() {
      const containerWidth = this.$refs.container.offsetWidth;
      const imageWidth = this.$refs.image.offsetWidth;
      this.maxScroll = Math.max(0, imageWidth - containerWidth);
    },
    startAnimation() {
      this.lastTime = performance.now();
      this.animationFrameId = requestAnimationFrame(this.animate);
    },
    animate(timestamp) {
      if (!this.lastTime) this.lastTime = timestamp;
      const deltaTime = timestamp - this.lastTime;
      this.lastTime = timestamp;

      // 计算像素位移
      const deltaPixels = (this.speed * deltaTime) / 1000;
      let newPosition = this.currentPosition + deltaPixels * this.direction;

      // 边界检查
      if (newPosition >= this.maxScroll) {
        newPosition = this.maxScroll;
        this.direction = -1;
      } else if (newPosition <= 0) {
        newPosition = 0;
        this.direction = 1;
      }

      this.currentPosition = newPosition;
      this.animationFrameId = requestAnimationFrame(this.animate);
    }
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationFrameId);
  },
};
</script>
<style scoped>
.image-container{
  width: 100%;
}
.company_container{
  width: 98vw;
  overflow: hidden;
}
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #05153B;
  overflow: hidden;
}

.footer_mn {
  width: 80vw;
  margin: auto;
}

.footer_center {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
}

.footer_top {
  border-bottom: 1px solid #505C76;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px 0 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .footer_bootom{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .footer_bootom_yin{
    display: none;
  }
  .footer_center_left{
    display: none;
  }
  .footer_top_right{
    margin-right: 30px;
  }
  .logo {
margin-left: 30px;
}
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
  .footer_mn{
    width: 98vw;
    margin: auto;
  }
  .footer_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

}


.footer_center_list {
  display: flex;
  justify-content: space-between;
  width: 42vw;

}

.footer_center_list>li{
   flex: 1;
   text-align: center;
}

.footer_center_list_item {
  margin-bottom: 10px;
}

.footer_center_right_item {
  display: flex;
  align-items: center;
}

.footer_center_right_item_img_box {
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer_bootom {
  border-top: 1px solid #505C76;
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
}

.footer_center_right_ewm_box {
  display: flex;
  column-gap: 15px;
  margin-left: 45px;
  margin-top: 20px;
}

.footer_center_right_ewm_box img {
  width: 62px;
  height: 62px;
  margin-bottom: 10px;
}

.footer_top_right {
  display: flex;
  column-gap: 10px;
  margin-bottom: 20px;
}

.footer_top_right img {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.footer_top_right .ewm{
  opacity: 0;
  width: 62px;
  height: 62px;
  position: absolute;
  top: -62px;
  left: -31px;

}
.footer_top_right_item{
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

}
.footer_top_right_item:hover .ewm{
  opacity: 1;
 
  
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue